<template>
  <div class="dashboard-container">
    <!-- Nowoczesny nagłówek -->
    <div class="page-header">
      <h2 class="page-title">📅 Kalendarz instalacji</h2>
      <div class="header-actions"> 
        <router-link to="/addinstallation">
          <button class="btn-action btn-add">
            <span class="action-icon">➕</span>
            <span class="action-text">Dodaj</span>
          </button>
        </router-link>
        <router-link to="/">
          <button class="btn-action">
            <span class="action-icon">📅</span>
            <span class="action-text">Kalendarz</span>
          </button>
        </router-link>
        <router-link to="/eventlist">
          <button class="btn-action">
            <span class="action-icon">📋</span>
            <span class="action-text">Lista</span>
          </button>
        </router-link>
       
      </div>
    </div>

    <!-- Kalendarz -->
    <div class="calendar-container">
    <vue-cal
      :events="events"
      :on-event-click="openInstallationModal"
      :disable-views="['years', 'year']"
      active-view="month"
      events-on-month-view="short"
      locale="pl"
    >
    </vue-cal>
    </div>

    <installation-modal
      @closeModal="closeModal()"
      :installation="installation"
    ></installation-modal>
  </div>
</template>

<script>
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/pl.es.js";
import "vue-cal/dist/vuecal.css";
import { mapState } from "vuex";
import InstallationModal from "../components/InstallationModal";
export default {
  data() {
    return {
      selectedEvent: {},
      showDialog: false,
      events: [],
      installation: "",
    };
  },
  components: {
    VueCal,
    "installation-modal": InstallationModal,
  },
  methods: {
    openInstallationModal(event, e) {
      console.log(event);
      this.$modal.show("installation-modal");
      this.installation = event;
      // Prevent navigating to narrower view (default vue-cal behavior).
      e.stopPropagation();
    },
    closeModal() {
      setTimeout(() => {
        this.events = [];
        console.log(this.installations);
        //   //   const item1 = this.config.chart.items["1"];
        //   //   item1.label = "label changed dynamically";
        //   //   item1.time.end += 2 * 24 * 60 * 60 * 1000;
        this.setEvents();
      }, 100);
      this.$modal.hide("installation-modal");
    },
    setEvents() {
      // Zabezpieczenie przed pustą lub undefined tablicą
      if (!this.installations || !Array.isArray(this.installations) || this.installations.length === 0) {
        return;
      }

      // Wyczyść istniejące wydarzenia
      this.events = [];

      function Event(start, end, title, content, installation, classStyle) {
        (this.start = start),
          (this.end = end),
          (this.title = title),
          (this.content = content);
        this.contractor = installation.contractor;
        this.installation = installation;
        this.class = classStyle;
      }

      this.installations.forEach((doc) => {
        if (doc.service && doc.service != doc.date) {
          let event = new Event(
            doc.service,
            doc.service,
            // "label",
            doc.contractor.label + " | " + doc.squad,
            doc.notice,
            doc,
            "binder" + doc.binder
          );
          this.events.push(event);
        }

        let event = new Event(
          doc.date,
          doc.date,
          doc.contractor.label + " | " + doc.squad,
          // "label",
          doc.notice,
          doc,
          "installation"
        );
        this.events.push(event);
      });
    },
  },
  computed: {
    ...mapState(["userProfile", "installations"]),
  },
  watch: {
    // Obserwuj zmiany w installations i aktualizuj wydarzenia
    installations: {
      handler() {
        if (this.installations && this.installations.length > 0) {
          this.setEvents();
        }
      },
      deep: true
    }
  },
  mounted() {
    // Pobierz dane tylko jeśli nie ma żadnych instalacji w store
    if (!this.installations || !Array.isArray(this.installations) || this.installations.length === 0) {
      const limits = this.$store.state.userProfile.limits;
      const limit = (limits && limits.installations) || 1000;
      this.$store.dispatch("getInstallations", { limit });
    } else {
      // Jeśli dane już są, załaduj wydarzenia od razu
      this.setEvents();
    }
  },
  beforeDestroy() {
    // Zakomentowane aby zachować dane w store
    // this.$store.commit('unsubscribeListener', 'installations');
  },
};
</script>

<style scoped>
/* --- Kontener główny --- */
.dashboard-container {
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;
}

/* --- Nagłówek strony --- */
.page-header {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.page-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.header-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.header-actions a {
  text-decoration: none;
}

.btn-action {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  text-decoration: none;
}

.btn-action:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-add {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  box-shadow: 0 2px 8px rgba(17, 153, 142, 0.3);
}

.btn-add:hover {
  box-shadow: 0 4px 12px rgba(17, 153, 142, 0.4);
}

.action-icon {
  font-size: 18px;
}

.action-text {
  font-size: 14px;
}

/* --- Kontener kalendarza --- */
.calendar-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 20px;
  overflow: hidden;
}

/* --- Responsywność --- */
@media (max-width: 768px) {
  .dashboard-container {
    padding: 12px;
  }

  .page-header {
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
  }

  .page-title {
    font-size: 22px;
  }

  .header-actions {
    width: 100%;
  }

  .btn-action {
    flex: 1;
    justify-content: center;
  }

  .action-text {
    display: none;
  }

  .calendar-container {
    padding: 12px;
    border-radius: 8px;
  }
}
</style>

<style>
/* --- Style Vue-Cal (nieobjęte scoped) --- */
.vuecal__cell {
  min-height: 100px;
}
.vuecal__cell-date {
  position: absolute;
  top: 3px;
  right: 5px;
}

.vuecal__event {
  cursor: pointer;
  border: 1px solid white;
  font-weight: 700;
  color: #000;
}

.vuecal__event.leisure {
  background-color: rgba(253, 156, 66, 0.9);
  border: 1px solid rgb(233, 136, 46);
  color: #fff;
}
.vuecal__event.sport {
  background-color: rgba(255, 102, 102, 0.9);
  border: 1px solid rgb(235, 82, 82);
  color: #fff;
}
.vuecal__event.test {
  background-color: gold;
}
.vuecal__event.installation {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: 1px solid #667eea;
}
.vuecal__event.binderundefined {
  background-color: white;
}
.vuecal__event.binder1 {
  color: #fff;
  background-color: #ff0033;
}
.vuecal__event.binder2 {
  background-color: #ff66cc;
}
.vuecal__event.binder3 {
  background-color: #ff00ff;
}
.vuecal__event.binder4 {
  color: #fff;
  background-color: #9900ff;
}
.vuecal__event.binder5 {
  color: #fff;
  background-color: #6633ff;
}
.vuecal__event.binder6 {
  color: #fff;
  background-color: #0033ff;
}
.vuecal__event.binder7 {
  background-color: #33ffff;
}
.vuecal__event.binder8 {
  background-color: #66ff66;
}
.vuecal__event.binder9 {
  background-color: #339900;
}
.vuecal__event.binder10 {
  background-color: #999900;
}
.vuecal__event.binder11 {
  background-color: #ffff00;
}
.vuecal__event.binder12 {
  color: #fff;
  background-color: #1b5e20;
}
.vuecal__event.binder13 {
  color: #fff;
  background-color: #996666;
}
</style>
